import React from 'react';
import { getEffectiveStatus, getStatusClass, getStatusLabel } from '../utils/status';

function formatReviewedDate(dateString) {
  if (!dateString) return '';
  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
    });
  } catch (err) {
    return '';
  }
}

// Renders the user-facing status for a request row. When the linguist
// has approved the translation we show an "Approved" badge with a hover
// tooltip carrying the reviewer's identity / date - this lets us drop
// the separate "Reviewed" column from the Files grid (status now
// conveys the same information, with the detail one hover away).
function StatusCell({ request }) {
  const effective = getEffectiveStatus(request);
  const isApproved = effective === 'approved';
  const isRetryPending = effective === 'retry_pending';
  const className = `status-badge ${getStatusClass(effective)}`;
  const retryMessage = request.message || request.error_message || '';

  if (!isApproved) {
    if (isRetryPending && retryMessage) {
      return (
        <span className={className} title={retryMessage}>
          {getStatusLabel(effective)}
        </span>
      );
    }
    return <span className={className}>{getStatusLabel(effective)}</span>;
  }

  const reviewer = request.reviewed_by || 'a linguist';
  const reviewedAt = formatReviewedDate(request.reviewed_at);
  const a11yLabel = `Reviewed by Linguist. By ${reviewer}${reviewedAt ? ` on ${reviewedAt}` : ''}.`;

  return (
    <span
      className="approved-badge-wrapper"
      tabIndex={0}
      aria-label={a11yLabel}
      title={a11yLabel}
    >
      <span className={className}>Approved</span>
      <span className="approved-badge-tooltip" role="tooltip">
        <div className="approved-badge-tooltip-header">Reviewed by Linguist</div>
        <div className="approved-badge-tooltip-body">
          By {reviewer}
          {reviewedAt ? ` on ${reviewedAt}` : ''}
        </div>
      </span>
    </span>
  );
}

export default StatusCell;
